define('taoQtiItem/qtiItem/core/choices/GapText',['taoQtiItem/qtiItem/core/choices/TextVariableChoice'], function(QtiTextVariableChoice){
    var QtiGapText = QtiTextVariableChoice.extend({
        qtiClass : 'gapText'
    });
    return QtiGapText;
});



